import algoliasearch from 'algoliasearch/lite';
import recommend from '@algolia/recommend';

const {
  REACT_APP_ALGOLIA_ID,
  REACT_APP_ALGOLIA_KEY,
  REACT_APP_ALGOLIA_PREFIX,
} = process.env;

if (!REACT_APP_ALGOLIA_ID) {
  throw Error('must define REACT_APP_ALGOLIA_ID in environment');
}
if (!REACT_APP_ALGOLIA_KEY) {
  throw Error('must define REACT_APP_ALGOLIA_KEY in environment');
}
if (!REACT_APP_ALGOLIA_PREFIX) {
  throw Error('must define REACT_APP_ALGOLIA_PREFIX in environment');
}

export const algoliaClient = algoliasearch(
  REACT_APP_ALGOLIA_ID,
  REACT_APP_ALGOLIA_KEY,
);

export const recommendClient = recommend(REACT_APP_ALGOLIA_ID, REACT_APP_ALGOLIA_KEY);

// Algolia client used for search bar due to algolia fires an empty search on page load to warm up the network connection
// We don't want it because it has a cost associated with it.
export const algoliaClientNoDupeRequest = algoliasearch(
  REACT_APP_ALGOLIA_ID,
  REACT_APP_ALGOLIA_KEY,
  {
    // this is needed to prevent duplicated requests when people type in the search box
    _useRequestCache: true
  }
);

// Main index names for product and collection
export const INDEX_COLLECTIONS = `${REACT_APP_ALGOLIA_PREFIX || ''}collections`;
export const INDEX_PRODUCTS = `${REACT_APP_ALGOLIA_PREFIX || ''}products`;
export const ALGOLIA_BASE_FILTERS = '(inStock:true OR isForcedSoldOut:1 OR isStayInCollection:1) AND isOnline:true AND (NOT isNfs:true)';

// Get Algolia userToken to for Algolia personalisation: https://www.algolia.com/doc/guides/sending-events/implementing/best-practices/usertoken/#getting-the-usertoken
// eslint-disable-next-line import/no-mutable-exports
let userToken;

if (window.aa) {
  window.aa('getUserToken', null, (err, newUserToken) => {
    if (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      return;
    }
    userToken = newUserToken;
  });
}
export { userToken };

// Set default current index to localStorage
if (!localStorage.getItem('ck_current_index')) {
  localStorage.setItem('ck_current_index', INDEX_PRODUCTS);
}
